// Shared numeric formatters for StatCard consumers.
//
// Extracted from apps/admin DashboardPage.formatCents / EventReportSection's
// formatCents+formatAvgSeconds (previously duplicated verbatim in both files,
// plus a third copy in SupervisorDashboardPage.formatAvgSeconds — not
// migrated in this pass, out of scope). See admin-ticket-analytics-dashboard
// design D6.

/** Formats integer cents as a localized currency string (e.g. 125000 → "$1,250.00"). */
export function formatCents(cents: number, currency: string): string {
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  } catch {
    // Fallback if the currency code is not recognised by Intl
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}

/** Formats a duration in whole seconds as a compact human string (e.g. 185 → "3m 5s"). */
export function formatAvgSeconds(seconds: number): string {
  if (seconds === 0) return '0s';
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return s > 0 ? `${m}m ${s}s` : `${m}m`;
}
